import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class DynamicTableService {

  constructor(private apiService: ApiBaseService) { }

  

  async getDynamicTableList(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('DynamicTableService/GetDynamicTableList', payLoad, true, true);
  }
  async getDynamicTableData(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('DynamicTableService/GetDynamicTableData', payLoad, true, true);
  }
  async getDynamicTable(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('DynamicTableService/GetDynamicTable', payLoad, true, true);
  }
  async WriteDynamicTable(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('DynamicTableService/WriteDynamicTable', payLoad, true, true);
  }
  async DuplicateDynamicTable(payLoad: { tableId: number; title: string }): Promise<any> {
    return this.apiService.httpRequest('DynamicTableService/DuplicateDynamicTable', payLoad, true, true);
  }
  async GetFieldLookup(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('DynamicTableService/GetFieldLookup', payLoad, true, true);
  }
  async FavoriteTable(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('DynamicTableService/FavouriteTable', payLoad, true, true);
  }
  

}
